var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: _vm.transitionName },
      on: { "after-enter": _vm.onEnter, "after-leave": _vm.onLeave },
    },
    [
      _c("div", { staticClass: "ui-snackbar", on: { click: _vm.onClick } }, [
        _c(
          "div",
          {
            staticClass: "ui-snackbar-message",
            style: { color: _vm.$themeTokens.textInverted },
          },
          [
            _vm._t("default", function () {
              return [_vm._v(_vm._s(_vm.message))]
            }),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "ui-snackbar-action" },
          [
            _vm.action
              ? _c(
                  "KButton",
                  {
                    staticClass: "ui-snackbar-action-button",
                    attrs: {
                      appearanceOverrides: {
                        color: _vm.$themeTokens.textInverted,
                      },
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.onActionClick.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n        " + _vm._s(_vm.action) + "\n      ")]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }